import { render, staticRenderFns } from "./PFOnlyCompleteRemittanceFields.vue?vue&type=template&id=51c4d5b6"
import script from "./PFOnlyCompleteRemittanceFields.vue?vue&type=script&lang=js"
export * from "./PFOnlyCompleteRemittanceFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports